
import "./Header.css";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../context";
import { headerMenuType } from "../../interfaces";
import { useNavigate, useLocation } from "react-router-dom";
import projectLogo from "../../Assets/PX.png";
import billionLogo from "../../Assets/BL.png";
import Logout from "./Logout";

function Header() {

    const {
        navbarData,
        toggleMenuItem,
        setOpenLogout,
        deActivePage
    } = useGlobalContext()

    const navigate = useNavigate();
    const location = useLocation();

    const [showNavigation, setShowNavigation] = useState<boolean>(false);

    useEffect((): void => {
        const findActivePage: headerMenuType | undefined = navbarData.find((data: headerMenuType) => "/" + data.title.toLowerCase() === location.pathname.toLowerCase());
        if (findActivePage) {
            toggleMenuItem(findActivePage.id);
        }
        else {
            deActivePage();
        }
        if (location.pathname.includes("billing")) setShowNavigation(false);
        else setShowNavigation(true);

    }, [location.pathname]);

    const backToDashboard = ():void => {
        if (showNavigation) {
            navigate("/main");
        }
        else {
            navigate("/billing-clients");
        }
    }

    return(
        <div className="mainHeader-container">
            <div className="mainHeader-box">
                <div className="mainHeader-box-logo">
                    <img onClick = { backToDashboard } src = { !showNavigation ? billionLogo : projectLogo } alt = ""/>
                </div>
                <div className="mainHeader-box-menu">
                    {
                        showNavigation ?
                            navbarData.map((item: headerMenuType, index: number) =>
                                <span
                                    key = { index }
                                    className = "mainHeaderMenuItem"
                                    onClick = { ():void => {
                                        toggleMenuItem(item.id);
                                        navigate(`/${item.title}`.toLowerCase());
                                    }}
                                    style = {{
                                        color: item.active ? "#004DE7" : "#999999",
                                    }}
                                >
                                    { item.title }
                                </span>
                            )
                        :
                            <span
                                className = "mainHeaderMenuItem"
                                onClick = {() => navigate("/main")}
                            >
                                Project X
                            </span>
                    }
                </div>
                <div className="mainHeader-box-logOut">
                    <span onClick = { (): void => setOpenLogout(true) }> Log Out </span>
                </div>
            </div>
            <Logout/>
        </div>
    )
}

export default Header;
